import { BasePaginationXsState } from '../../../base/base-pagination-xs.state';
import { JobTemplateModel } from '../../../../models/job_template/job-template.model';
import { BasePaginationStateModel } from '../../../base/model/base-pagination-state.model';
import { PaginationInterface } from '../../../interfaces/model/pagination.interface';
import { SortColumnInterface } from '../../../interfaces/model/sort-column.interface';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { DynamicFilterSortModel } from '../../../../models/dynamic-filter/dynamic-filter-sort.model';
import { SortColumnHeader } from '../../../../content/components/sort-column-header/sort-column-header';
import {
  JOB_ROUTINE_TEMPLATE_COLUMNS
} from '../../../../content/components/sort-column-header/job-routine-template-sort-column/sort-columns';
import { Injectable } from '@angular/core';
import { JobRoutineTemplateFilterService } from '../../../../services/filter/job-routine-template-filter.service';
import { DynamicFilterEntryDto } from '../../../../models/dynamic-filter/dynamic-filter-entry-dto.model';
import { RequestAction } from '../../../common/request.actions';
import { DynamicFilterRequestDto } from '../../../../models/dynamic-filter/dynamic-filter-request-dto.model';
import { OaSelectJobroutineActions } from './oa-select-jobroutine.actions';
import { CompoApp } from '../../../../services/CompoApp';
import { ObjectActionXsState } from '../object-action-xs.state';
import { HeaderClientService } from '../../../../services/client/header-service/header-client.service';
import {
  JobRoutineReplacementJobActionEnum
} from '../../../../models/dynamic-filter/dynamic-filter-object-action-jobroutine-bulk-dto.model';
import { ObjectDetailModel } from '../../../../models/component/page/detail/object-detail.model';
import { PaginationClientService } from '../../../../services/client/base/pagination-client.service';
import { ServiceProvider } from '../../../../models/service_provider/ServiceProvider';
import { Organization } from '../../../../models/organization/Organization';
import { AssigneeEntityType } from '../../../../enums/frontend/AssigneeEntityType';
import { WorkGroup } from '../../../../models/work_group/WorkGroup';
import { User } from '../../../../models/user/User';
import { DynamicFilterTemplatePage } from '../../../../models/dynamic-filter/dynamic-filter-template-page.model';
import { FilterTemplateEntryName } from '../../../../enums/dynamic-filter/filter-template-entry-name.enum';
import Status = RequestAction.Status;
import { ObjectFilterUtil } from '../../../../utils/filter/object-filter.util';

export class OaSelectJobroutineActionsModel extends BasePaginationStateModel<OaSelectJobroutineActionsModel, JobTemplateModel> implements PaginationInterface<JobTemplateModel>,
  SortColumnInterface {

  //region pagination
  pageSize: number;
  currentPage: number;
  totalPages: number;
  totalCount: number;

  values: any;

  fetchedPages: Set<number>;
  fetchTimestamp: number;

  filterForm: UntypedFormGroup;
  filterSettings: DynamicFilterTemplatePage;
  filterEntryMap: Map<string, string>;

  selectionMode: 'Single' | 'Multi';
  //endregion pagination

  //region pagination 2
  pageSize2: number;
  currentPage2: number;
  totalPages2: number;
  totalCount2: number;

  values2: any;

  fetchedPages2: Set<number>;
  fetchTimestamp2: number;

  filterForm2: UntypedFormGroup;
  filterSettings2: DynamicFilterTemplatePage;
  filterEntryMap2: Map<string, string>;

  selectionMode2: 'Single' | 'Multi';
  //endregion pagination 2

  //region sorting
  gridTemplateColumn: string;

  sorting: DynamicFilterSortModel[];
  sortColumns: SortColumnHeader[];

  selectedColumns: UntypedFormGroup;
  //endregion sorting

  //region request
  currentRequest: RequestAction.Status;
  //endregion request

  jobroutineTemplateSelectedIds: Set<string>;
  jobroutineTemplate: JobTemplateModel;


  selectedObjectIdsForReplacement: string[];
  jobRoutineTemplateReplaceTarget: JobTemplateModel;
  jobRoutineTemplateReplaceSource: JobTemplateModel;
  affectedJobsAction: JobRoutineReplacementJobActionEnum;
  responsibilityExtern: boolean;
  responsibleServiceProvider: ServiceProvider;
  responsibleOrganization: Organization;
  assigneeType: AssigneeEntityType;//user or work group
  assigneeUser: User;
  assigneeWorkGroup: WorkGroup;
  countOfObjectsUsingJobRoutineTemplateToBeReplaced: number;
  countOfObjectsCompatibleWithReplacementJobRoutine: number;
  objectsCurrentlyUsingTargetJobRoutineTemplate: ObjectDetailModel[];
  objectIdsValidForJobRoutineReplacement: string[];
  hasIncompatibleObjectsForReplacement: boolean;
}

@State<OaSelectJobroutineActionsModel>({
  name: 'OaSelectJobroutine',
  defaults: {

    //region pagination
    pageSize: 25,
    currentPage: 0,
    totalPages: 0,
    totalCount: 0,

    values: Array.from({ length: 25 }),
    fetchedPages: new Set(),
    fetchTimestamp: null,

    filterForm: new UntypedFormGroup({}),
    filterSettings: null,
    filterEntryMap: new Map<string, string>(),

    selectionMode: 'Single',
    //endregion pagination

    //region pagination 2 (replacement)
    pageSize2: 25,
    currentPage2: 0,
    totalPages2: 0,
    totalCount2: 0,

    values2: Array.from({ length: 25 }),
    fetchedPages2: new Set(),
    fetchTimestamp2: null,

    filterForm2: new UntypedFormGroup({}),
    filterSettings2: null,
    filterEntryMap2: new Map<string, string>(),

    selectionMode2: 'Single',
    //endregion pagination 2

    //region sorting
    gridTemplateColumn: SortColumnHeader.concatGridTemplateColumns(JOB_ROUTINE_TEMPLATE_COLUMNS),

    sorting: [],
    sortColumns: JOB_ROUTINE_TEMPLATE_COLUMNS,

    selectedColumns: new UntypedFormGroup({ selectedColumns: new UntypedFormControl([]) }),
    //endregion sorting

    //region request
    currentRequest: RequestAction.Status.NONE,
    //endregion request

    jobroutineTemplateSelectedIds: new Set(),
    jobroutineTemplate: null,

    selectedObjectIdsForReplacement: [],
    jobRoutineTemplateReplaceTarget: null,
    jobRoutineTemplateReplaceSource: null,
    affectedJobsAction: null,
    responsibilityExtern: true,
    responsibleServiceProvider: null,
    responsibleOrganization: null,
    assigneeType: AssigneeEntityType.USER,//user or work group
    assigneeUser: null,
    assigneeWorkGroup: null,
    countOfObjectsUsingJobRoutineTemplateToBeReplaced: null,
    countOfObjectsCompatibleWithReplacementJobRoutine: null,
    objectsCurrentlyUsingTargetJobRoutineTemplate: [],
    hasIncompatibleObjectsForReplacement: false,
    objectIdsValidForJobRoutineReplacement: []
  }
})
@Injectable()
export class OaSelectJobroutineXsState extends BasePaginationXsState<OaSelectJobroutineActionsModel, JobTemplateModel> {

  constructor(
    protected app: CompoApp,
    private store: Store,
    private headerService: HeaderClientService,
  ) {
    super(app);
  }

  //region SELECTORS
  //region pagination
  @Selector()
  static selectionMode(state: OaSelectJobroutineActionsModel): string {
    return state.selectionMode;
  }

  @Selector()
  static multiSelection(state: OaSelectJobroutineActionsModel): boolean {
    return state.selectionMode === 'Multi';
  }

  @Selector()
  static multiSelection2(state: OaSelectJobroutineActionsModel): boolean {
    return state.selectionMode2 === 'Multi';
  }

  @Selector()
  static filterForm(state: OaSelectJobroutineActionsModel): UntypedFormGroup {
    return state.filterForm;
  }

  @Selector()
  static filterSearchTermControlName(state: OaSelectJobroutineActionsModel): string {
    const id = state.filterEntryMap.get(JobRoutineTemplateFilterService.SEARCH_TERM);

    if (id) return id.toString();

    return '';
  }

  @Selector()
  static filterSearchTermControlName2(state: OaSelectJobroutineActionsModel): string {
    const id = state.filterEntryMap2.get(JobRoutineTemplateFilterService.SEARCH_TERM);

    if (id) return id.toString();

    return '';
  }

  @Selector()
  static filterSettings(state: OaSelectJobroutineActionsModel): DynamicFilterTemplatePage {
    return state.filterSettings;
  }

  @Selector()
  static filterSettings2(state: OaSelectJobroutineActionsModel): DynamicFilterTemplatePage {
    return state.filterSettings2;
  }

  @Selector()
  static filterSettingsEntries(state: OaSelectJobroutineActionsModel): Record<FilterTemplateEntryName, DynamicFilterEntryDto> {
    return state.filterSettings.filterEntries;
  }

  @Selector()
  static filterSettingsEntries2(state: OaSelectJobroutineActionsModel): Record<FilterTemplateEntryName, DynamicFilterEntryDto> {
    return state.filterSettings2.filterEntries;
  }

  @Selector()
  static values(state: OaSelectJobroutineActionsModel): JobTemplateModel[] {
    return state.values;
  }

  @Selector()
  static values2(state: OaSelectJobroutineActionsModel): JobTemplateModel[] {
    return state.values2;
  }

  @Selector()
  static selectedJobRoutineTemplateIds(state: OaSelectJobroutineActionsModel): Set<string> {
    return new Set(state.jobroutineTemplateSelectedIds);
  }

  @Selector()
  static jobroutineTemplate(state: OaSelectJobroutineActionsModel): JobTemplateModel {
    return state.jobroutineTemplate;
  }

  @Selector()
  static jobroutineTemplateToBeReplaced(state: OaSelectJobroutineActionsModel): JobTemplateModel {
    return state.jobRoutineTemplateReplaceTarget;
  }

  @Selector()
  static replacementJobroutineTemplate(state: OaSelectJobroutineActionsModel): JobTemplateModel {
    return state.jobRoutineTemplateReplaceSource;
  }

  @Selector()
  static countOfObjectsUsingJobRoutineTemplateToBeReplaced(state: OaSelectJobroutineActionsModel): number {
    return state.countOfObjectsUsingJobRoutineTemplateToBeReplaced;
  }

  @Selector()
  static canSaveReplaceJobRoutine(state: OaSelectJobroutineActionsModel): boolean {
    return state.affectedJobsAction !== null && !state.hasIncompatibleObjectsForReplacement;
  }

  @Selector()
  static affectedJobsAction(state: OaSelectJobroutineActionsModel): JobRoutineReplacementJobActionEnum {
    return state.affectedJobsAction;
  }

  @Selector()
  static responsibilityExtern(state: OaSelectJobroutineActionsModel): boolean {
    return state.responsibilityExtern;
  }
  @Selector()
  static responsibleServiceProvider(state: OaSelectJobroutineActionsModel): ServiceProvider {
    return state.responsibleServiceProvider;
  }
  @Selector()
  static responsibleOrganization(state: OaSelectJobroutineActionsModel): Organization {
    return state.responsibleOrganization;
  }
  @Selector()
  static assigneeType(state: OaSelectJobroutineActionsModel): AssigneeEntityType {
    return state.assigneeType;
  }
  @Selector()
  static assigneeUser(state: OaSelectJobroutineActionsModel): User {
    return state.assigneeUser;
  }
  @Selector()
  static assigneeWorkGroup(state: OaSelectJobroutineActionsModel): WorkGroup {
    return state.assigneeWorkGroup;
  }

  @Selector()
  static countOfObjectsCompatibleWithReplacementJobRoutine(state: OaSelectJobroutineActionsModel): number {
    return state.countOfObjectsCompatibleWithReplacementJobRoutine;
  }

  @Selector()
  static objectsValidForJobRoutineReplacement(state: OaSelectJobroutineActionsModel): string[] {
    return state.objectIdsValidForJobRoutineReplacement;
  }

  @Selector()
  static objectsCurrentlyUsingTargetJobRoutineTemplate(state: OaSelectJobroutineActionsModel): ObjectDetailModel[] {
    return state.objectsCurrentlyUsingTargetJobRoutineTemplate;
  }

  @Selector()
  static selectedJobRoutineTemplateIdsArray(state: OaSelectJobroutineActionsModel): string[] {
    return [...(state.jobroutineTemplateSelectedIds || [])];
  }

  //endregion pagination

  //region sorting
  @Selector()
  static sorting(state: OaSelectJobroutineActionsModel): DynamicFilterSortModel[] {
    return state.sorting;
  }

  @Selector()
  static sortColumns(state: OaSelectJobroutineActionsModel): SortColumnHeader[] {
    return state.sortColumns;
  }

  @Selector()
  static visibleSortColumns(state: OaSelectJobroutineActionsModel): SortColumnHeader[] {
    return state.sortColumns.filter(column => column.visible);
  }

  @Selector()
  static selectedColumns(state: OaSelectJobroutineActionsModel): UntypedFormGroup {
    return state.selectedColumns;
  }

  @Selector()
  static gridTemplateColumns(state: OaSelectJobroutineActionsModel): string {
    return state.gridTemplateColumn;
  }

  //endregion sorting
  //endregion SELECTORS

  //region ACTIONS
  //region pagination
  @Action(OaSelectJobroutineActions.ResetPagination)
  public resetPagination(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.ResetPagination) {
    const state = ctx.getState();

    ctx.patchState({
      currentRequest: Status.NONE,
      values: Array.from({ length: state.pageSize }),
      fetchedPages: new Set()
    });
  }

  @Action(OaSelectJobroutineActions.ResetPagination2)
  public resetPagination2(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.ResetPagination2) {
    const state = ctx.getState();

    ctx.patchState({
      currentRequest: Status.NONE,
      values2: Array.from({ length: state.pageSize }),
      fetchedPages2: new Set()
    });
  }

  @Action(OaSelectJobroutineActions.FetchPageSettings)
  public fetchPageSettings(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.FetchPageSettings) {
    super.paginationFetchPageSettings(ctx, action.pageEnum);
  }

  @Action(OaSelectJobroutineActions.FetchPageSettings2)
  public fetchPageSettings2(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.FetchPageSettings2) {
    this._dynamicFilterTemplateService.getByPageEnum(action.pageEnum)
      .then(resp => {
        this.paginationPatchStateOnSettingsCallback2(ctx, resp);
      })
      .catch(error => {
        console.dir(error);
        this.paginationPatchStateOnSettingsCallback2(ctx, null);
      });
  }

  protected paginationPatchStateOnSettingsCallback(ctx: StateContext<OaSelectJobroutineActionsModel>, filterSettings) {
    const state = ctx.getState(), filterEntryMap = new Map<string, string>();

    if (filterSettings) {
      const filterEntry = filterSettings.filterEntries[JobRoutineTemplateFilterService.SEARCH_TERM];
      if (filterEntry) {
        filterEntryMap.set(JobRoutineTemplateFilterService.SEARCH_TERM, filterEntry.id);
      }
    }

    ctx.patchState({
      filterEntryMap: filterEntryMap,
      filterSettings: filterSettings
    });
  }

  protected paginationPatchStateOnSettingsCallback2(ctx: StateContext<OaSelectJobroutineActionsModel>, filterSettings) {
    const state = ctx.getState(), filterEntryMap = new Map<string, string>();

    if (filterSettings) {
      const filterEntry = filterSettings.filterEntries[JobRoutineTemplateFilterService.SEARCH_TERM];
      if (filterEntry) {
        filterEntryMap.set(JobRoutineTemplateFilterService.SEARCH_TERM, filterEntry.id);
      }
    }

    ctx.patchState({
      filterEntryMap2: filterEntryMap,
      filterSettings2: filterSettings
    });
  }

  @Action(OaSelectJobroutineActions.FetchPage)
  public fetchPage(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.FetchPage) {
    const state = ctx.getState(), page = action.page, dto = action.dto,
      fetchedPages = state.fetchedPages, pageSize = state.pageSize,
      values = state.values;

    const fetchTimestamp = super.paginationFetchPage(page, fetchedPages, dto);

    //page should not be fetched -> virtual scrollable container is not big enough.
    if (fetchTimestamp === -1) return;

    //page is already fetched
    if (fetchTimestamp === -2) return;

    //continue
    ctx.patchState({
      fetchTimestamp: fetchTimestamp
    });

    super.paginationDoRequest(ctx, page, pageSize, dto, fetchedPages, values, fetchTimestamp);
  }

  @Action(OaSelectJobroutineActions.FetchPages)
  public fetchPages(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.FetchPages) {
    const state = ctx.getState(), fetchedPages = state.fetchedPages, pageSize = state.pageSize,
      values = state.values, currentRequest = state.currentRequest;
    let dto = action.dto;

    if (!state.filterSettings) return;

    //a request is currently executed
    if (currentRequest === RequestAction.Status.PENDING) return;

    if (!dto) {
      dto = this.paginationGetFilterDto(ctx, action.filterValues);
    }

    const selectedIds = action.selectedIds;
    if (selectedIds.length > 0) {
      ctx.patchState({ selectedObjectIdsForReplacement: [...selectedIds] });
      dto.selectedIds = selectedIds;
    }

    if ((!selectedIds || selectedIds.length === 0) && state.selectedObjectIdsForReplacement?.length > 0) {
      dto.selectedIds = state.selectedObjectIdsForReplacement;
    }

    //There might not be an implementation yet!
    if (!dto) return;

    const pages = super.paginationOnEvent(action.event, pageSize);

    //No pages to fetch
    if (pages.length < 1) return;

    const fetchTimestamp = super.paginationFetchPage(pages[0], fetchedPages, dto);

    //page should not be fetched -> virtual scrollable container is not big enough.
    if (fetchTimestamp === -1) return;

    //page is already fetched
    if (fetchTimestamp === -2) return;

    //continue
    ctx.patchState({
      fetchTimestamp: fetchTimestamp,
      currentRequest: RequestAction.Status.PENDING
    });

    pages.forEach(page => {
      super.paginationDoRequest(ctx, page, pageSize, dto, fetchedPages, values, fetchTimestamp);
    });
  }

  @Action(OaSelectJobroutineActions.FetchPages2)
  public fetchPages2(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.FetchPages2) {
    const state = ctx.getState(), fetchedPages = state.fetchedPages2, pageSize = state.pageSize2,
      values = state.values2, currentRequest = state.currentRequest;
    let dto = action.dto;

    if (!state.filterSettings2) return;

    //a request is currently executed
    if (currentRequest === RequestAction.Status.PENDING) return;

    if (!dto) {
      dto = this.paginationGetFilterDto2(ctx, action.filterValues);
    }

    const selectedIds = action.selectedIds;
    if (selectedIds.length > 0) {
      ctx.patchState({ selectedObjectIdsForReplacement: [...selectedIds] });
      dto.selectedIds = selectedIds;
    }

    if ((!selectedIds || selectedIds.length === 0) && state.selectedObjectIdsForReplacement?.length > 0) {
      dto.selectedIds = state.selectedObjectIdsForReplacement;
    }

    //There might not be an implementation yet!
    if (!dto) return;

    const pages = super.paginationOnEvent(action.event, pageSize);

    //No pages to fetch
    if (pages.length < 1) return;

    const fetchTimestamp = super.paginationFetchPage(pages[0], fetchedPages, dto);

    //page should not be fetched -> virtual scrollable container is not big enough.
    if (fetchTimestamp === -1) return;

    //page is already fetched
    if (fetchTimestamp === -2) return;

    //continue
    ctx.patchState({
      fetchTimestamp2: fetchTimestamp,
      currentRequest: RequestAction.Status.PENDING
    });

    pages.forEach(page => {
      this.paginationDoRequest2(ctx, page, pageSize, dto, fetchedPages, values, fetchTimestamp);
    });
  }

  private paginationDoRequest2(
    ctx: StateContext<OaSelectJobroutineActionsModel>,
    page: number,
    pageSize: number,
    dto: DynamicFilterRequestDto,
    fetchedPages: Set<number>,
    values: JobTemplateModel[],
    fetchTimestamp: number
  ): void {
    this._dynamicFilterTemplateService.searchWithFilterDto(page, pageSize, dto)
      .then(resp => {

        setTimeout(() => {
          const [array, totalCount, totalPages] = this.paginationOnCallback(resp, values, pageSize);
          this.paginationPatchStateOnCallback2(
            ctx,
            array,
            fetchedPages.add(page),
            totalCount ? totalCount : 0,
            totalPages ? totalPages : 0
          );
        }, PaginationClientService.calcTimeoutValue(fetchTimestamp));
      })
      .catch(error => {
        console.dir(error);
        fetchedPages.delete(page);
        this.paginationPatchStateOnError2(ctx, fetchedPages);
      });
  }

  protected paginationCreateFilterDto(): DynamicFilterRequestDto {
    return undefined;
  }

  protected paginationGetFilterDto(ctx: StateContext<OaSelectJobroutineActionsModel>, filterValues: any): DynamicFilterRequestDto {
    const request = new DynamicFilterRequestDto(), state = ctx.getState(), filterSettings = state.filterSettings;
    request.templateId = filterSettings?.id;

    request.filterValues = DynamicFilterRequestDto.initFilterValues(filterSettings.filterEntries, filterValues);
    request.filterRangeValues = DynamicFilterRequestDto.initFilterRangeValues(filterSettings.filterEntries, filterValues);
    request.filterAttributeValues = DynamicFilterRequestDto.initFilterAttributeValues(filterSettings.filterEntries, filterValues);

    request.orgIds = this.headerService.getAllOrgIds();
    request.locationIds = this.headerService.getAllLocationIds();

    request.sortDtos = state.sorting;

    return request;
  }

  protected paginationGetFilterDto2(ctx: StateContext<OaSelectJobroutineActionsModel>, filterValues: any): DynamicFilterRequestDto {
    const request = new DynamicFilterRequestDto(), state = ctx.getState(), filterSettings = state.filterSettings2;
    request.templateId = filterSettings?.id;

    request.filterValues = DynamicFilterRequestDto.initFilterValues(filterSettings.filterEntries, filterValues);
    request.filterRangeValues = DynamicFilterRequestDto.initFilterRangeValues(filterSettings.filterEntries, filterValues);
    request.filterAttributeValues = DynamicFilterRequestDto.initFilterAttributeValues(filterSettings.filterEntries, filterValues);

    request.orgIds = this.headerService.getAllOrgIds();
    request.locationIds = this.headerService.getAllLocationIds();

    request.sortDtos = state.sorting;
    request.excludedIds = [state.jobRoutineTemplateReplaceTarget?.id];

    return request;
  }

  protected paginationPatchStateOnCallback(
    ctx: StateContext<OaSelectJobroutineActionsModel>,
    values: JobTemplateModel[],
    fetchedPages: Set<number>,
    totalCount: number,
    totalPages: number
  ): void {
    ctx.patchState({
      currentRequest: RequestAction.Status.SUCCESS,
      values: values,
      fetchedPages: fetchedPages,
      totalCount: totalCount,
      totalPages: totalPages
    });
  }

  protected paginationPatchStateOnCallback2(
    ctx: StateContext<OaSelectJobroutineActionsModel>,
    values: JobTemplateModel[],
    fetchedPages: Set<number>,
    totalCount: number,
    totalPages: number
  ): void {
    ctx.patchState({
      currentRequest: RequestAction.Status.SUCCESS,
      values2: values,
      fetchedPages2: fetchedPages,
      totalCount2: totalCount,
      totalPages2: totalPages
    });
  }

  protected paginationPatchStateOnError(
    ctx: StateContext<OaSelectJobroutineActionsModel>,
    fetchedPages: Set<number>
  ): void {
    ctx.patchState({
      currentRequest: RequestAction.Status.ERROR,
      fetchedPages: fetchedPages
    });
  }

  protected paginationPatchStateOnError2(
    ctx: StateContext<OaSelectJobroutineActionsModel>,
    fetchedPages: Set<number>
  ): void {
    ctx.patchState({
      currentRequest: RequestAction.Status.ERROR,
      fetchedPages2: fetchedPages
    });
  }

  //endregion pagination

  //region sorting
  @Action(OaSelectJobroutineActions.SetSortColumnHeaders)
  public setSortColumnHeaders(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.SetSortColumnHeaders) {
    ctx.patchState({
      sortColumns: action.columns,
      gridTemplateColumn: super.sortingGridTemplateColumn(ctx.getState().sortColumns)
    });
  }

  @Action(OaSelectJobroutineActions.OnColumnHeaderClick)
  public onColumnHeaderClick(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.OnColumnHeaderClick) {
    //region action impl.
    const state = ctx.getState();

    if (!this.store.selectSnapshot(ObjectActionXsState.jobroutineActionDialogVisible)) return;

    //columnField is required to execute common logic!
    if (!action.columnField || action.columnField.length <= 0) return;

    const columnIdx = state.sortColumns.findIndex(c => c.columnField === action.columnField);
    if (columnIdx === -1) return;

    if (!state.sortColumns[columnIdx].visible) return;

    if (state.sortColumns[columnIdx].disabledSort) return;

    const newSorting = super.sortingOnColumnHeaderClick([...state.sorting], action.columnField);
    const newSortColumns = super.sortingOnColumnHeaderClickSortColumns([...state.sortColumns], action.columnField, newSorting);
    ctx.patchState({
      sortColumns: newSortColumns,
      sorting: newSorting,
      gridTemplateColumn: super.sortingGridTemplateColumn(state.sortColumns)
    });
    //endregion action impl.
  }

  //endregion sorting

  @Action(OaSelectJobroutineActions.SetReplacementJobRoutineTargetId)
  public setReplacementJobroutineTemplate(ctx: StateContext<OaSelectJobroutineActionsModel>,
                                          action: OaSelectJobroutineActions.SetReplacementJobRoutineTargetId) {
    if (!action?.jobRoutineTemplate) return;

    ctx.patchState({
      jobRoutineTemplateReplaceSource: action.jobRoutineTemplate
    });
  }

  @Action(OaSelectJobroutineActions.SetReplacementJobRoutineSourceToBeReplacedId)
  public setReplaceMentJobRoutineTargetId(ctx: StateContext<OaSelectJobroutineActionsModel>,
                                          action: OaSelectJobroutineActions.SetReplacementJobRoutineTargetId) {
    if (!action?.jobRoutineTemplate) return;

    ctx.patchState({
      jobRoutineTemplateReplaceTarget: action.jobRoutineTemplate
    });
  }

  @Action(OaSelectJobroutineActions.SetCountOfObjectsAffectedByJobRoutineReplacement)
  public setCountOfObjectsAffectedBrJobRoutineReplacement(ctx: StateContext<OaSelectJobroutineActionsModel>,
                                                          action: OaSelectJobroutineActions.SetCountOfObjectsAffectedByJobRoutineReplacement) {
    if (!action.countOfObjectsWithJobRoutineToReplace) return;

    ctx.patchState({
      countOfObjectsUsingJobRoutineTemplateToBeReplaced: action.countOfObjectsWithJobRoutineToReplace
    });
  }

  @Action(OaSelectJobroutineActions.SetCountOfObjectsCompatibleWithReplacementJobRoutine)
  public setCountOfObjectsCompatibleWithReplacementJobRoutine(ctx: StateContext<OaSelectJobroutineActionsModel>,
                                                              action: OaSelectJobroutineActions.SetCountOfObjectsCompatibleWithReplacementJobRoutine) {
    if (!action.countOfObjectsCompatibleWithReplacementJobRoutine) return;

    ctx.patchState({
      countOfObjectsCompatibleWithReplacementJobRoutine: action.countOfObjectsCompatibleWithReplacementJobRoutine
    });
  }

  @Action(OaSelectJobroutineActions.SetObjectsCurrentlyUsingTargetJobRoutineTemplate)
  public setObjectsCurrentlyUsingTargetJobRoutineTemplate(ctx: StateContext<OaSelectJobroutineActionsModel>,
                                                          action: OaSelectJobroutineActions.SetObjectsCurrentlyUsingTargetJobRoutineTemplate) {
    if (!action.objects) return;

    ctx.patchState({
      objectsCurrentlyUsingTargetJobRoutineTemplate: action.objects
    });
  }

  @Action(OaSelectJobroutineActions.SetObjectsValidForJobRoutineReplacement)
  public setObjectsValidForJobRoutineReplacement(ctx: StateContext<OaSelectJobroutineActionsModel>,
                                                 action: OaSelectJobroutineActions.SetObjectsValidForJobRoutineReplacement) {

    if (!action.objects) return;

    ctx.patchState({
      objectIdsValidForJobRoutineReplacement: action.objects
    });
  }

  @Action(OaSelectJobroutineActions.SetJobRoutineReplacementJobAction)
  public setJobRoutineReplacementJobAction(ctx: StateContext<OaSelectJobroutineActionsModel>,
                                           action: OaSelectJobroutineActions.SetJobRoutineReplacementJobAction) {

    if (!action.jobRoutineReplacementJobAction) return;

    ctx.patchState({
      affectedJobsAction: action.jobRoutineReplacementJobAction
    });
  }

  @Action(OaSelectJobroutineActions.SetJobRoutineReplacementResponsibilityValues)
  public setJobRoutineReplacementResponsibilityValues(ctx: StateContext<OaSelectJobroutineActionsModel>,
                                                      action: OaSelectJobroutineActions.SetJobRoutineReplacementResponsibilityValues) {

    if (!action
      || action.responsibilityExtern === undefined
      || action.responsibilityExtern === null
      || !action.assigneeType
    ) {
      return;
    }


    ctx.patchState({
      responsibilityExtern: action.responsibilityExtern,
      responsibleServiceProvider: action.responsibleServiceProvider,
      responsibleOrganization: action.responsibleOrganization,
      assigneeType: action.assigneeType,
      assigneeUser: action.assigneeUser,
      assigneeWorkGroup: action.assigneeWorkGroup
    });
  }

  @Action(OaSelectJobroutineActions.SetHasInvalidObjectsForReplacement)
  public setHasInvalidObjectsForReplacement(ctx: StateContext<OaSelectJobroutineActionsModel>,
                                            action: OaSelectJobroutineActions.SetHasInvalidObjectsForReplacement) {

    if (action.hasInvalidObjectsForReplacement == null) return;

    ctx.patchState({
      hasIncompatibleObjectsForReplacement: action.hasInvalidObjectsForReplacement
    });
  }

  @Action(OaSelectJobroutineActions.ForJobRoutineTemplate)
  public forJobRoutineTemplate(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.ForJobRoutineTemplate) {

    if (!action?.jobRoutineTemplate) return;

    const singleSelection: boolean = ctx.getState().selectionMode === 'Single';
    let selectedIds = new Set<string>();

    if (singleSelection) {
      if (!ctx.getState().jobroutineTemplateSelectedIds.has(action.jobRoutineTemplate.id)) {
        selectedIds.add(action.jobRoutineTemplate.id);
      }
    } else {
      selectedIds = new Set<string>(ctx.getState().jobroutineTemplateSelectedIds);

      const isSelected = selectedIds.has(action.jobRoutineTemplate.id);
      if (isSelected) {
        selectedIds.delete(action.jobRoutineTemplate.id);
      } else {
        selectedIds.add(action.jobRoutineTemplate.id);
      }
    }

    ctx.patchState({
      values: [...ctx.getState().values.map(entry => {
        if (entry) {
          entry = { ...entry };
          if (selectedIds.has(entry.id)) {
            entry.isChecked = true;
          } else if (entry) {
            entry.isChecked = false;
          }
        }
        return entry;
      })],
      jobroutineTemplateSelectedIds: selectedIds
    });
  }

  @Action(OaSelectJobroutineActions.SetJobRoutineTemplate)
  public setJobRoutineTemplate(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.SetJobRoutineTemplate) {
    ctx.patchState({
      jobroutineTemplate: { ...action.model }
    });
  }

  @Action(OaSelectJobroutineActions.Clear)
  public clear(ctx: StateContext<OaSelectJobroutineActionsModel>, action: OaSelectJobroutineActions.Clear) {
    ctx.dispatch(new OaSelectJobroutineActions.ResetPagination());
    ctx.patchState({
      jobroutineTemplateSelectedIds: new Set<string>(),
      // jobRoutineTemplateReplaceTarget: null,
      // jobRoutineTemplateReplaceSource: null,
      affectedJobsAction: null,
      countOfObjectsUsingJobRoutineTemplateToBeReplaced: null,
      countOfObjectsCompatibleWithReplacementJobRoutine: null,
      objectsCurrentlyUsingTargetJobRoutineTemplate: []
    });
  }

  @Action(OaSelectJobroutineActions.SetSelectionMode)
  public setSelectionMode(
    ctx: StateContext<OaSelectJobroutineActionsModel>,
    action: OaSelectJobroutineActions.SetSelectionMode
  ) {
    if (action.mode) {
      ctx.patchState({
        selectionMode: action.mode,
        jobroutineTemplateSelectedIds: new Set()
      });
    }
  }

  //endregion ACTIONS
}
